var $ = window.jQuery;

$(document).ready(function () {
  const table = $('.spreadsheet_table');
  const sheet_id = table.attr('data-id');
  const env = table.attr('data-env');
  const isDev = env === 'development';
  let sheet_tab = '';

  if (table.length) {
    sheet_tab = table.attr('data-tab').split(' ').join('+');
  }

  let API = `https://${
    isDev ? 'dev-sheet' : 'sheet'
  }.simplertrading.io/${sheet_id}/${sheet_tab}`;
  if (table.length) {
    $.ajax({
      url: API,
      type: 'POST',
      dataType: 'json',
      headers: {
        Authorization: btoa('dilSuBtGcFZzxBnOctCP'),
        'Content-Type': 'application/json',
      },
      success: function (res) {
        let headers = Object.keys(Object.assign({}, ...res));
        headers = headers.map((header) => {
          let obj = {
            data: header,
            title: header,
          };
          return obj;
        });
        $('.spreadsheet_table').DataTable({
          data: res,
          columns: headers,
          columnDefs: [
            {
              defaultContent: '-',
              targets: '_all',
            },
          ],
          order: [],
        });

        table.wrap("<div class='scroll_div'></div>");
      },
      error: function (err) {
        console.error(err);
      },
    });
  }
});
